import { supabase } from './supabase'
import type { MenuLang } from '../components/menu/menuI18n'

/**
 * QR menü çevirileri: çeviri fonksiyonunu çağırmak ve patronun düzeltmeleri.
 * Tablo ve kurallar: supabase/qr-menu-ceviri.sql.
 */

export type TxKind = 'p' | 'c' | 't'

export interface TxRow {
  kind: TxKind
  item_id: string
  lang: Exclude<MenuLang, 'tr'>
  name: string
  description: string | null
  src: string
  manual: boolean
}

/** Tablodaki src ile aynı biçim: Türkçesi değişince çeviri eskimiş sayılıyor. */
export const productSrc = (name: string, description?: string | null) => `${name}\n${description ?? ''}`

export interface TranslateResult {
  translated: number
  error?: string
}

/** Eksik ya da eskimiş çevirileri tamamlatır. Değişen yoksa çeviri servisine gidilmez. */
export async function requestTranslation(tenantId: string): Promise<TranslateResult> {
  if (!supabase) return { translated: 0, error: 'Supabase yapılandırılmamış' }
  const { data, error } = await supabase.functions.invoke('translate-menu', { body: { tenantId } })
  if (error) {
    // Fonksiyonun kendi hata metni, gövdede.
    const body = await (error as { context?: Response }).context?.json?.().catch(() => null)
    return { translated: 0, error: body?.error ?? error.message }
  }
  return { translated: data?.translated ?? 0, error: data?.errors?.length ? data.errors.join('; ') : undefined }
}

export async function fetchTranslations(tenantId: string, lang: TxRow['lang']): Promise<TxRow[]> {
  if (!supabase) return []
  const { data, error } = await supabase
    .from('menu_translations')
    .select('kind, item_id, lang, name, description, src, manual')
    .eq('tenant_id', tenantId)
    .eq('lang', lang)
  if (error) throw new Error(error.message)
  return (data ?? []) as TxRow[]
}

/** Patronun düzeltmesi: elle işaretleniyor, Türkçesi değişene kadar korunuyor. */
export async function saveTranslation(tenantId: string, row: Omit<TxRow, 'manual'>): Promise<void> {
  if (!supabase) throw new Error('Supabase yapılandırılmamış')
  const { error } = await supabase.from('menu_translations').upsert({
    tenant_id: tenantId,
    ...row,
    manual: true,
    updated_at: new Date().toISOString(),
  })
  if (error) throw new Error(error.message)
}
